__turbopack_context__.v({
  "className": "ibm_plex_mono_16c602b4-module__eTD9uq__className",
});
